<template>
   <div class="container-wrapper">
      <div class="breadcrumb-wrapper">平安合作配置</div>

      <div class="margin-left-20">
         <el-button :type="currentIndex == 0 ? 'primary' : 'plain'" @click="clickHomeConfig">首页配置</el-button>
         <el-button :type="currentIndex == 1 ? 'primary' : 'plain'" @click="clickMedalConfig">勋章配置</el-button>
      </div>

      <HomeConfiguration v-if="currentIndex == 0" ref="homeRef" />
      <MedalConfiguration v-if="currentIndex == 1" ref="medalRef" />
   </div>
</template>

<script>
import HomeConfiguration from './HomeConfiguration.vue';
import MedalConfiguration from './MedalConfiguration.vue';

export default {
   components: {
      HomeConfiguration,
      MedalConfiguration
   },

   data() {
      return {
         currentIndex: 0,
      }
   },

   methods: {
      // 点击首页配置按钮
      clickHomeConfig() {
         if (this.currentIndex == 0) {
            return;
         }
         this.currentIndex = 0;
      },
      // 点击勋章配置按钮
      clickMedalConfig() {
         if (this.currentIndex == 1) {
            return;
         }
         this.currentIndex = 1;
      }
   },

   beforeRouteEnter(to, from, next) {
      if (from.path === '/yunying/advertising/pingan/home/config') {
         to.meta.refresh = true;
      }
      if (from.path === '/yunying/advertising/pingan/medal/config') {
         to.meta.refresh = true;
      }
      next();
   },
   activated() {
      if (this.$route.meta.refresh) {
         this.$route.meta.refresh = false;
         if (this.currentIndex == 0) {
            this.$refs.homeRef.queryList();
         } else if (this.currentIndex == 1) {
            this.$refs.medalRef.queryList();
         }
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// CooperationConfig.vue?2ab2be16